const GetImageUrl = (id: string) => {
  return `https://www.eventshoppe.co.in:9021/file-system/image/${id}`
}

export default GetImageUrl
